module.exports = {"text":"module.exports = __webpack_public_path__ + \"static/media/close.f2e9c8ca.svg\";"};
module.exports['default'] = module.exports;
